"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = _interopRequireWildcard(require(".."));
var Components = _;
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _awsAmplify = require("aws-amplify");
var _2 = require(".");
var FormComponents = _interopRequireWildcard(require("../Forms"));
var _md = _interopRequireDefault(require("md5"));
var _uuid = require("uuid");
var _v = _interopRequireDefault(require("uuid/v1"));
var _WebRequestHelper = require("../../helpers/WebRequestHelper");
var _components = require("../../components");
var _icon = _interopRequireDefault(require("./../../../fonts/icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable react/jsx-no-undef */
const mapStateToProps = (state, props) => {
  return {
    [props.entity.plural]: state[props.entity.plural]
  };
};
const mapDispatchToProps = (dispatch, props) => {
  return {
    create: (0, _redux.bindActionCreators)(props.actions.create, dispatch),
    getSchema: (0, _redux.bindActionCreators)(props.actions.getSchema, dispatch)
  };
};
class UploadMediaTable extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "toggleModalDialog", () => {
      this.setState({
        modalDialogOpen: !this.state.modalDialogOpen
      });
    });
    _defineProperty(this, "handleDeleteSelected", () => {
      this.setState(prev => {
        var newDataToUpload = Object.values(prev.dataToUpload).filter(item => {
          if (prev.selection.includes(item.id)) console.log("deleting: " + item.id);
          return !prev.selection.includes(item.id);
        });
        return {
          dataToUpload: newDataToUpload,
          filesToUpload: newDataToUpload,
          selection: []
        };
      });
      this.toggleModalDialog();
    });
    _defineProperty(this, "handleSelect", (bool, id) => {
      if (bool) return this.setState(prev => {
        return {
          selection: [...prev.selection, id]
        };
      });
      return this.setState(prev => {
        return {
          selection: prev.selection.filter(p => p !== id)
        };
      });
    });
    _defineProperty(this, "handleSelectAll", (bool, id) => {
      if (bool) {
        const all = Object.values(this.state.dataToUpload).map(item => item.id);
        return this.setState({
          selection: all
        });
      }
      return this.setState({
        selection: []
      });
    });
    _defineProperty(this, "onAddFiles", event => {
      let filesToUpload = event.target.files;
      let filesToData = event.target.files;
      this.setState({
        dataToUpload: [],
        // Every time the user select new files,
        filesToUpload: [] // we clear the previous ones
      });
      for (let file of Object.values(filesToData)) {
        var fileName = file.name;
        var fileNameNoExtension = fileName.substr(0, fileName.lastIndexOf(".")) || fileName;
        file.id = (0, _uuid.v4)();
        file.displayName = fileNameNoExtension;
        file.languages = [];
        file.products = [];
        file.showrooms = [];

        // var reader = new FileReader();
        // reader.readAsDataURL(filesToData[0]);
        // reader.onload = function () {
        // 	console.log(reader.result);
        // 	file.thumbnail = <img width="100" src={`${reader.result}`} />
        // 	console.log(file.thumbnail)
        // };
        // reader.onerror = function (error) {
        // 	console.log('Error: ', error);
        // };

        // for (let i = 0; i < filesToData.length; i++) {
        // 	file.thumbnail = <img width="125px" src={URL.createObjectURL(filesToData[i])} />
        // }

        file = this.checkFileType(file);

        // this.setState({
        // 	thumbnail: reader.result
        // });
      }
      this.setState({
        dataToUpload: filesToData,
        filesToUpload: filesToUpload
      });
    });
    _defineProperty(this, "checkFileType", file => {
      for (let key in file) {
        if (key === "type") {
          if (file[key].match("application/pdf")) {
            file.fileType = 3;
            file.thumbnail = /*#__PURE__*/_react.default.createElement("img", {
              width: "80px",
              src: "data:image/png;base64,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"
            });
            // file.thumbnail = this.state.thumbnail
          } else if (file[key].match("image.*")) {
            file.fileType = 4;
            file.thumbnail = /*#__PURE__*/_react.default.createElement("img", {
              width: "80px",
              src: "data:image/png;base64,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"
            });
          } else if (file[key].match("audio.*")) {
            file.fileType = 5;
            file.thumbnail = /*#__PURE__*/_react.default.createElement("img", {
              width: "80px",
              src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVQAAAD6CAIAAABxkSjIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAITGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNi4wLWMwMDUgNzkuMTY0NTkwLCAyMDIwLzEyLzA5LTExOjU3OjQ0ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdEV2dD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlRXZlbnQjIiB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjIuMSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDIxLTAyLTA5VDE1OjI3OjU1KzAxOjAwIiB4bXA6TWV0YWRhdGFEYXRlPSIyMDIxLTAyLTA5VDE1OjI3OjU1KzAxOjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMS0wMi0wOVQxNToyNzo1NSswMTowMCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxNzFhNDBiNC03YmFjLWY1NDgtOTY5OC1hZjg2ZjhmNzU4NTMiIHhtcE1NOkRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo5MGE5ZTYzZS0xZGM0LWQzNDEtYjRjYi05MWQ3OThjOGU4MDIiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo3YjdiNDgwMS05OWQ2LTUzNDAtOWI5MC0wM2QzYjgyNDQwZGEiIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJjcmVhdGVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjdiN2I0ODAxLTk5ZDYtNTM0MC05YjkwLTAzZDNiODI0NDBkYSIgc3RFdnQ6d2hlbj0iMjAyMS0wMi0wOVQxNToyNzo1NSswMTowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIi8+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJzYXZlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDoxNzFhNDBiNC03YmFjLWY1NDgtOTY5OC1hZjg2ZjhmNzU4NTMiIHN0RXZ0OndoZW49IjIwMjEtMDItMDlUMTU6Mjc6NTUrMDE6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyMi4xIChXaW5kb3dzKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPHBob3Rvc2hvcDpUZXh0TGF5ZXJzPiA8cmRmOkJhZz4gPHJkZjpsaSBwaG90b3Nob3A6TGF5ZXJOYW1lPSLupIQiIHBob3Rvc2hvcDpMYXllclRleHQ9Iu6khCIvPiA8cmRmOmxpIHBob3Rvc2hvcDpMYXllck5hbWU9Inp0IiBwaG90b3Nob3A6TGF5ZXJUZXh0PSLupIoiLz4gPHJkZjpsaSBwaG90b3Nob3A6TGF5ZXJOYW1lPSJ6dCBLb3BpZSIgcGhvdG9zaG9wOkxheWVyVGV4dD0i7qSdIi8+IDxyZGY6bGkgcGhvdG9zaG9wOkxheWVyTmFtZT0iTG9yZW0gaXBzdW0gZG9sb3Igc2l0IGFtZXQsIGNvbnNlY3RldHVyIGFkaXBpc2NpbmcgZWxpdCwgc2VkIGRvIiBwaG90b3Nob3A6TGF5ZXJUZXh0PSJMb3JlbSBpcHN1bSBkb2xvciBzaXQgYW1ldCwgY29uc2VjdGV0dXIgYWRpcGlzY2luZyBlbGl0LCBzZWQgZG8gZWl1c21vZCB0ZW1wb3IgaW5jaWRpZHVudCB1dCBsYWJvcmUgZXQgZG9sb3JlIG1hZ25hIGFsaXF1YS4gUXVpcyBpcHN1bSBzdXNwZW5kaXNzZSB1bHRyaWNlcyBncmF2aWRhLiBSaXN1cyBjb21tb2RvIHZpdmVycmEgbWFlY2VuYXMgYWNjdW1zYW4gbGFjdXMgdmVsIGZhY2lsaXNpcy4gIi8+IDwvcmRmOkJhZz4gPC9waG90b3Nob3A6VGV4dExheWVycz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz71bHpFAAAFLElEQVR42u3dWVIqSwBF0Tv/wRWtdCJN0Qgilg1i73sfGcEQ7sc9aw0hif0hZnL+/AdE+uMIQPyA+AHxA+IHxA+IHxA/IH5A/ID4AfED4gfED4gfED8gfkD8gPgB8QPiB8QPiB8QP4gfED8gfkD8gPgB8QPiB8QPiB8QPyB+QPyA+AHxA+IHxA+IHxA/IH5A/ID4AfED4gfxA+IHxA+IHxA/IH5A/ID4AfED4gfED4gfED8gfkD8gPgB8QPiB8QPiP/f8PPz4xAQf6K6rtfr9ff3t6NA/FmWy2VVVd1u93A4/P7+OhDEnxV/MRwOX15enAnij4u/mM1mHx8fTgbxx8VfVVWr1dput74LRPxx8Re9Xu94PDoixB8XfzEej0+nk4NC/HHxF4vF4vPz03Eh/rj4q6pqt9u73c4XAYg/Lv6i3+83TePcEH9c/MX19fX5fHZ6iD8u/qKu66+vL2eI+OPir6qq0+nc3d25F4z44+IvBoPB8/Ozw0T8cfEXNzc37+/vjhTxx8Vf7gVvNhsPhBF/XPxFt9u9v7/3RQDij4u/GI1GHggj/sT4i/l87oGw+EmMv9wLvr29dS9Y/MTFf3kg/PDw4MDFT1z8lwfCr6+vjl38xMVfLJdLD4TFT2L85YuA/X7v34HiJy7+4urq6vHx0acgfuLivzwQfnt781mIn7j4y73g1WrlXrD4iYv/8kDYcJD4SYz/MhzkgbD4SYzfA2HxEx2/B8LiJzf+ywNhw0HiJzH+ywNhw0HiJzF+w0HiJzp+D4TFT278hoPET3T8xWQyMRwkfhLjNxwkfqLjNxwkfnLjvwwHPT09+UzFT1z8xXQ6dS9Y/CTGX+4Fr9dr94LFT1z8hoPET3T8lwfChoPET2L8xWw2MxwkfhLjL18EbLdb94LFT1z8heEg8RMaf2E4SPyExl8YDhK/+HO12+3dbuffgeIXfyjDQeIXfzTDQeIXf7TVauWBsPjFH8oDYfGLP9pgMDAcJH7x5zIcJH7x56rr2p8A4hd/lslk4iKg+MWfxRMA8Ys/8c6fURDxiz/OfD737F/84s8yGo384I/4xZ/FT/2JX/xx/Miv+MXv9g7iF3/GvV3DPuInK34vdsRPYvzGfMVPXPyTyeR8PvusxU9Q/P1+v2kan7L4CYq//DKnW7riJyv+xWLhN7nFT1b84/H4dDr5WMVPUPy9Xu94PPpAxU9Q/K1Wa7PZ+PNe/GTFP5vN3NIVP1nxD4dDv64rfrLi73Q6h8PBLV3xExR/q9VarVYe4YqfrPin06ktPfGTFb8VXfETF3+73d7v9/68Fz9Z8S+XS49wxU9W/KZyxE9c/KZyxE9c/KZyxE9i/KZyxE9c/KZyxE9c/KZyxE9c/KZyxE9i/KZyxE9c/KZyxE9c/KZyxE9i/KZyxE9c/KZyEH9c/KZyEH9c/KZyEH9i/KZyEH9c/KZyEH9c/KZyEH9c/KZyEH9i/KZyEH9c/KZyEH9c/KZyEH9c/KZyEH9i/KZyEH9c/KZyEH9c/KZyEH9i/KZyEH9c/KZyEH9c/P1+31QO4s+K31QO4k/UNI2pHMQPiB8QPyB+QPyA+AHxA+IHxA/iB8QPiB8QPyB+QPyA+AHxA+IHxA+IHxA/IH5A/ID4AfED4gfED4gfED8gfkD8gPhB/I4AxA+IHxA/IH5A/ID4AfED4gfED4gfED8gfkD8gPgB8QPiB8QPiB8QPyB+QPyA+AHxg/gB8QPiB8QPiB8QPyB+QPyA+AHxA+IHxA+IH/ib/gddFgwmF87meQAAAABJRU5ErkJggg=="
            });
          } else if (file[key].match("video.*")) {
            file.fileType = 6;
            file.thumbnail = /*#__PURE__*/_react.default.createElement("img", {
              width: "80px",
              src: "data:image/png;base64,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"
            });
          } else file.fileType = 0;
        }
      }
      return file;
    });
    _defineProperty(this, "onChangeFields", (row, value, column) => {
      if (column === "displayName") {
        this.setState(state => {
          let dataToUpload = Object.values(state.dataToUpload).map((item, j) => {
            if (item.id === row.id) {
              item.displayName = value;
              return item;
            } else {
              return item;
            }
          });
          return {
            dataToUpload
          };
        });
      } else if (column === "languages") {
        let selectedLanguages = value;
        this.setState(state => {
          let dataToUpload = Object.values(state.dataToUpload).map((item, j) => {
            if (item.id === row.id) {
              item.languages = selectedLanguages;
              return item;
            } else {
              return item;
            }
          });
          return {
            dataToUpload
          };
        });
      } else if (column === "products") {
        let selectedProducts = value;
        this.setState(state => {
          let dataToUpload = Object.values(state.dataToUpload).map((item, j) => {
            if (item.id === row.id) {
              item.products = selectedProducts;
              return item;
            } else {
              return item;
            }
          });
          return {
            dataToUpload
          };
        });
      } else if (column === "showrooms") {
        let selectedShowrooms = value;
        this.setState(state => {
          let dataToUpload = Object.values(state.dataToUpload).map((item, j) => {
            if (item.id === row.id) {
              item.showrooms = selectedShowrooms;
              return item;
            } else {
              return item;
            }
          });
          return {
            dataToUpload
          };
        });
      }
    });
    _defineProperty(this, "onUpload", () => {
      this.setState({
        fetching: true
      });
      for (let file of this.state.dataToUpload) {
        this.createJsonToUpload(file).then(jsonToUpload => {
          this.uploadFiles(jsonToUpload);
        });
      }
    });
    _defineProperty(this, "createJsonToUpload", file => {
      return this.fileToByteArray(file) // We convert the file to byte array in order to calculate the md5 hash.
      .then(byteArray => {
        let jsonToUpload = {
          Id: file.id,
          Name: file.name,
          DisplayName: file.displayName,
          Type: file.fileType,
          LocalPath: file.name,
          Size: file.size,
          Hash: (0, _md.default)(byteArray),
          ContentFileLanguages: [],
          ProductViShowContentFiles: [],
          ShowroomViShowContentFiles: []
        };
        if (file.languages) {
          for (let language of file.languages) {
            jsonToUpload.ContentFileLanguages.push({
              LanguageId: language.LanguageId
            });
          }
        }
        if (file.products) {
          for (let product of file.products) {
            jsonToUpload.ProductViShowContentFiles.push({
              ProductId: product.ProductId
            });
          }
        }
        if (file.showrooms) {
          for (let showroom of file.showrooms) {
            jsonToUpload.ShowroomViShowContentFiles.push({
              ShowroomId: showroom.ShowroomId
            });
          }
        }
        return jsonToUpload;
      }).catch(error => {
        console.dir(error);
        this.setState({
          fetching: false
        });
        this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
      });
    });
    _defineProperty(this, "uploadFiles", jsonToUpload => {
      const {
        create
      } = this.props;
      _awsAmplify.Auth.currentSession().then(data => {
        create(JSON.stringify(jsonToUpload), data.idToken.jwtToken).then(response => {
          this.uploadToS3(response.Url, jsonToUpload.Id);
        }).catch(error => {
          console.dir(error);
          this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
          this.setState({
            fetching: false
          });
        });
      }).catch(error => {
        console.dir(error);
        this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
        this.setState({
          fetching: false
        });
      });
    });
    _defineProperty(this, "uploadToS3", (bucketUrl, fileId) => {
      const {
        filesToUpload
      } = this.state;
      (0, _WebRequestHelper.createRequest)(false).then(request => {
        request.method = "put";
        request.baseURL = bucketUrl;
        for (let file of filesToUpload) {
          if (file.id === fileId) {
            request.data = file;
            (0, _WebRequestHelper.sendRequest)(request).then(response => {
              this.message(`File(s) successfully uploaded`);
              this.setState({
                fetching: false
              });
            }).catch(error => {
              console.dir(error);
              this.setState({
                fetching: false
              });
              this.throw(`Oops, something went wrong`);
            });
          }
        }
      }).catch(error => {
        console.dir(error);
        this.setState({
          fetching: false
        });
        this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
      });
    });
    _defineProperty(this, "throw", message => {
      this.setState(prev => {
        return {
          errors: [{
            Id: (0, _uuid.v4)(),
            Message: message
          }]
        };
      });
    });
    _defineProperty(this, "message", message => {
      this.setState(prev => {
        return {
          messages: [{
            Id: (0, _uuid.v4)(),
            Message: message
          }]
        };
      });
    });
    let schema = this.props.actions.getSchema();
    this.state = {
      dataToUpload: [],
      filesToUpload: [],
      schema: schema,
      fetching: false,
      errors: [],
      messages: [],
      thumbnail: null,
      modalDialogOpen: false,
      selection: []
    };
  }
  fileToByteArray(file) {
    return new Promise((resolve, reject) => {
      try {
        let reader = new FileReader();
        let fileByteArray = [];
        reader.readAsArrayBuffer(file);
        reader.onloadend = evt => {
          if (evt.target.readyState == FileReader.DONE) {
            let arrayBuffer = evt.target.result,
              array = new Uint8Array(arrayBuffer);
            for (let byte of array) {
              fileByteArray.push(byte);
            }
          }
          resolve(fileByteArray);
        };
      } catch (e) {
        reject(e);
      }
    });
  }
  onRead(id) {
    this.setState(prev => {
      return {
        errors: prev.errors.filter(error => error.Id !== id),
        messages: prev.messages.filter(message => message.Id !== id)
      };
    });
  }
  render() {
    const {
      values,
      selection,
      onClick,
      onSelect,
      fetched,
      onSelectAll,
      onChange,
      onAdd,
      onDrop,
      [this.props.entity.plural]: entity,
      ...rest
    } = this.props;
    const {
      dataToUpload,
      schema,
      fetching,
      errors,
      messages
    } = this.state;
    const uploadMediaColumns = Object.values(schema);
    if (fetching) return /*#__PURE__*/_react.default.createElement(_.Spinner, null);
    const allSelected = dataToUpload ? this.state.selection.length === dataToUpload.length : false;
    const uuid = (0, _v.default)();
    return /*#__PURE__*/_react.default.createElement("div", null, this.state.selection.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex justify-content-between align-items-center",
      style: {
        height: "3rem"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "text-left mt-1 mb-3"
    }, this.state.selection.length, " item", this.state.selection.length !== 1 && `s`, " selected"), /*#__PURE__*/_react.default.createElement("div", {
      className: "text-right"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn-lg btn-transparent mt-1 mb-3",
      onClick: this.toggleModalDialog
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "delete",
      size: 20
    })))), !!errors.length && errors.map(error => /*#__PURE__*/_react.default.createElement("div", {
      key: error.Id,
      className: "alert alert-danger alert-dismissible fade show mb-4"
    }, error.Message.length < 200 ? error.Message : "Oops, something went wrong.", /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: () => this.onRead(error.Id)
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7")))), !!messages.length && messages.map(message => /*#__PURE__*/_react.default.createElement("div", {
      key: message.Id,
      className: "alert alert-success alert-dismissible fade show mb-4"
    }, message.Message, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: () => this.onRead(message.Id)
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7")))), /*#__PURE__*/_react.default.createElement("div", {
      className: "mb-3"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "file",
      multiple: "multiple",
      style: {
        overflow: "hidden",
        position: "absolute",
        opacity: 0,
        zIndex: -1
      },
      id: "uploadFile",
      name: "uploadFile",
      onChange: this.onAddFiles,
      accept: "image/png,image/gif,image/jpeg,video/mp4,video/x-m4v,video/*,application/pdf"
    }), dataToUpload.length === 0 ? /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "uploadFile",
      className: "btn btn-secondary mr-4",
      style: {
        marginTop: "0.5rem"
      }
    }, "+ Add Media") : null, dataToUpload.length ? /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn-primary",
      onClick: this.onUpload
    }, "Upload") :
    // : <button className="btn btn-primary disabled" disabled>Upload</button>
    null), /*#__PURE__*/_react.default.createElement("table", {
      className: "table table-hover"
    }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
      className: "align-top table-header",
      scope: "col"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "custom-control custom-checkbox"
    }, /*#__PURE__*/_react.default.createElement("input", {
      id: uuid,
      type: "checkbox",
      className: "custom-control-input",
      onChange: event => this.handleSelectAll(event.target.checked),
      checked: allSelected
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: "custom-control-label d-block",
      htmlFor: uuid
    }))), uploadMediaColumns.map((column, index) => /*#__PURE__*/_react.default.createElement(_2.UploadTableColumnHeader, {
      key: index,
      column: column
    })))), /*#__PURE__*/_react.default.createElement("tbody", null, dataToUpload && Object.values(dataToUpload).map((row, indexRow) => {
      const selected = this.state.selection.some(selected => selected === row.id);
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: `${row.id || indexRow}-row`,
        className: selected ? "table-active" : ""
      }, /*#__PURE__*/_react.default.createElement("th", {
        style: {
          verticalAlign: "middle"
        },
        scope: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "custom-control custom-checkbox"
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: row.id,
        type: "checkbox",
        className: "custom-control-input",
        onChange: event => this.handleSelect(event.target.checked, row.id),
        checked: selected,
        disabled: !fetched
      }), /*#__PURE__*/_react.default.createElement("label", {
        className: "custom-control-label d-block",
        htmlFor: row.id
      }))), uploadMediaColumns.map((column, indexCol) => {
        const value = row[column.key];
        const Component = column.component || (column.editable ? FormComponents[column.type] : Components[column.type] || (() => /*#__PURE__*/_react.default.createElement("div", null, value ? JSON.stringify(value) : "")));
        return /*#__PURE__*/_react.default.createElement("td", {
          key: `${row.id || indexRow}-col-${indexCol}`,
          className: "position-relative",
          style: {
            verticalAlign: "middle"
          }
        }, onClick && row.id && /*#__PURE__*/_react.default.createElement(Link, {
          to: onClick(row.id),
          className: "table-link"
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: "position-relative",
          style: {
            cursor: "pointer"
          }
        }, column.type === "Join" ? /*#__PURE__*/_react.default.createElement(Component, {
          isMulti: true,
          row: row,
          entity: column.entities,
          onChange: val => this.onChangeFields(row, val, column.key),
          value: value,
          onAdd: onAdd,
          onDrop: onDrop,
          schema: column
        }) : /*#__PURE__*/_react.default.createElement(Component, _extends({}, rest, {
          row: row,
          value: value,
          format: column.format,
          fetched: fetched,
          fetching: fetching,
          onAdd: onAdd,
          onDrop: onDrop,
          schema: column,
          onChange: val => this.onChangeFields(row, val, column.key),
          edit: column.editable
        }))));
      }));
    }))), /*#__PURE__*/_react.default.createElement(_components.ModalDialog, {
      isOpen: this.state.modalDialogOpen,
      headerText: `You will delete ${this.state.selection.length} item${this.state.selection.length !== 1 ? `s` : ``}`,
      bodyText: "Are you sure? This action cannot be undone.",
      buttonSecOnClick: this.toggleModalDialog,
      buttonSecText: "Cancel",
      buttonPrimOnClick: this.handleDeleteSelected,
      buttonPrimText: "Delete"
    }));
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UploadMediaTable);
module.exports = exports.default;